module.exports = __webpack_public_path__ + "img/video-mobile.083749b.webp";